export default __webpack_public_path__ + "static/media/18.36947cfe.jpg";